import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
    selector: 'am-comments',
    templateUrl: './comments.component.html',
    styleUrls: ['./comments.component.scss'],
    standalone: true,
})
export class CommentsComponent implements AfterViewInit {
  @ViewChild('clarifications', { static: false }) clarificationsRef!: ElementRef<HTMLDivElement>;

  @Input() comments: string[];
  ngAfterViewInit(): void {
    this.insertComments();
  }

  insertComments(): void {
    if (!this.comments || this.comments.length === 0) return;
    if (!this.clarificationsRef) return;

    const htmlContent = this.comments.join('<br>');
    this.clarificationsRef.nativeElement.innerHTML = htmlContent;
  }
}
